// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__eq2sO","errors":"Errors_errors__1gEif"};